import { defineComponent as r, createBlock as n, openBlock as a, unref as l, mergeProps as c, withCtx as m, createElementVNode as p } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const f = /* @__PURE__ */ r({
  name: "IconScooter",
  __name: "IconScooter",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (d, e) => (a(), n(l(i), c(t, { "view-box": "0 0 24 24" }), {
      default: m(() => e[0] || (e[0] = [
        p("path", {
          "fill-rule": "evenodd",
          d: "M13 3.75a.75.75 0 0 0 0 1.5h2.874l1.24 6.593-.03.005a6.5 6.5 0 0 0-1.945.682 5.284 5.284 0 0 0-2 1.902c-.453.748-.764 1.676-.859 2.818H8.74a2.75 2.75 0 1 0-.289 1.5H13A.75.75 0 0 0 13.75 18c0-1.258.285-2.15.673-2.791a3.785 3.785 0 0 1 1.438-1.364A5 5 0 0 1 18 13.25h.003a.75.75 0 0 0 .735-.889l-1.503-8a.75.75 0 0 0-.738-.611H13m-7 15a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m12 0a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m0 1.5a2.75 2.75 0 1 0 0-5.5 2.75 2.75 0 0 0 0 5.5",
          "clip-rule": "evenodd"
        }, null, -1)
      ])),
      _: 1,
      __: [0]
    }, 16));
  }
});
export {
  f as default
};
